import { Business, PersonOutline } from '@mui/icons-material'
import { Box, Typography, useMediaQuery } from '@mui/material'
import AdxPopper from 'components/reusable/AdxPopper'
import { authContext } from 'contexts/AuthContext'
import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { useAdmin } from 'services/hooks/useAdmin'

export default function CompanyPopper({ menuShown }) {
  const { auth } = useContext(authContext)
  const [isAdmin, permissions] = useAdmin()
  const isLarge = useMediaQuery((theme) => theme.breakpoints.up('lg'))

  const companyManageMenus = [
    {
      title: 'Staff Management',
      link: '/app/management-centre/staff-management/employee-file',
      icon: <PersonOutline />,
      permissionId: 2,
    },
    {
      title: 'Company Management',
      link: '/app/management-centre/company-management/general',
      icon: <Business />,
      permissionId: 0,
    },
  ]

  const getFilteredMenus = () => {
    if (!permissions || typeof permissions !== 'object') return []
    return companyManageMenus.filter((menu) =>
      Object.keys(permissions).some(
        (key) => parseInt(key) === menu.permissionId && permissions[key] === menu.title
      )
    )
  }

  return (
    <AdxPopper
      disabled={!isAdmin || getFilteredMenus()?.length === 0}
      customButton={
        <Box
          display={'flex'}
          alignItems={'center'}
          gap={2}
          border={1}
          borderColor={'gray-line.main'}
          borderRadius={'4.5px'}
          minHeight={'50px'}
          p={menuShown ? 1.5 : 0.75}
          bgcolor={'white.main'}
          width={menuShown ? (isLarge ? '270px' : '305px') : 'fit-content'}
        >
          <Box
            width={'35px'}
            height={'35px'}
            bgcolor={
              auth?.data?.organization_detail?.organization_logo_url ? 'white' : 'alternate.main'
            }
            borderRadius={'100%'}
            overflow={'clip'}
          >
            <img
              src={auth?.data?.organization_detail?.organization_logo_url}
              width={'35px'}
              height={'35px'}
              // objectFit="cover"
              alt="avatar"
              style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
            />
          </Box>
          {menuShown && (
            <Box display={'flex'} flexDirection={'column'} width={'73%'}>
              <Typography
                sx={{
                  lineClamp: 1,
                  textWrap: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  width: '100%',
                }}
              >
                {auth?.data?.organization_detail?.organization_name}
              </Typography>
              {isAdmin && (
                <Typography
                  variant="body2"
                  sx={{ textDecoration: 'underline' }}
                  color="alternate.main"
                >
                  Manage
                </Typography>
              )}
            </Box>
          )}
        </Box>
      }
      placement="bottom-start"
      sx={{ marginBottom: 1, width: 1 }}
      linePlacement={[1]}
    >
      {getFilteredMenus().map((item, index) => {
        return (
          <Link key={index} to={item?.link} style={{ textDecoration: 'none' }}>
            <Box sx={{ display: 'flex', gap: 2, color: 'dark-text.main' }}>
              {item?.icon}
              <Typography>{item?.title}</Typography>
            </Box>
          </Link>
        )
      })}
    </AdxPopper>
  )
}
